// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.sandbox_container.SandboxContainer

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { SandboxData, SandboxStore } from "./Sandbox.generated";

export interface SandboxContainerData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "SandboxContainer";
    sandbox: SandboxData;
}

export class SandboxContainerStore {
    readonly _entity_class_name = "SandboxContainer" as const;
    sandbox: SandboxStore;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: SandboxContainerData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.sandbox = wrapEntity(data.sandbox, transport, [...chainPath, "sandbox"]);
        makeObservable(this, {
            sandbox: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }
}

registerEntity("SandboxContainer", SandboxContainerStore);
